<div class="p-grid">


    <div class="p-col-12 p-md-6">
		<div class="card">
			<h5>Detalle Incidente Horas</h5>
			<div class="p-fluid">
				<div class="p-field p-grid">
					<label for="userId" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Asigando a: * </label>
					<div class="p-col-12 p-md-10">
						<p-dropdown [options]="lstUsersSupportDoc" [(ngModel)]="selectedUsersSupport" placeholder="Seleccionar" optionLabel="userName" [showClear]="true"></p-dropdown>
                        <small class="p-error" *ngIf="!selectedUsersSupport">Seleccione asignado a.</small>
                    </div>
				</div>
				<div class="p-field p-grid">
					<label for="strDate" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">De la Fecha:</label>
					<div class="p-col-12 p-md-10">
						<p-calendar inputId="basic" [(ngModel)]="date1" [showIcon]="true" inputId="icon"></p-calendar>
                        <small class="p-error" *ngIf="!date1">Ingrese fecha de inicio.</small>
					</div>
				</div>
                <div class="p-field p-grid">
					<label for="endDate" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">A la Fecha:</label>
					<div class="p-col-12 p-md-10">
						<p-calendar inputId="basic" [(ngModel)]="date2" [showIcon]="true" inputId="icon"></p-calendar>
                        <small class="p-error" *ngIf="!date1">Ingrese fecha de fin.</small>
					</div>
				</div>
                
			</div>
            <div class="p-field">
                <button pButton pRipple label="buscar"  icon="pi pi-plus" class="p-button-info p-mr-2" (click)="search()"></button>
            </div>
		</div>
    </div> 

    <div class="p-col-12 p-md-12">
        <p-table #dt [value]="lstIncidentsAssigned"
            [rowHover]="true" dataKey="id" styleClass="p-datatable-responsive-demo"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [showCurrentPageReport]="true">
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <h5 class="p-m-0">Horas trabajadas</h5>
                    
                </div> 
                <span class="p-input-icon-left">
                    <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
                </span>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>          
                    <th pSortableColumn="incidentId">Id Incidente<p-sortIcon field="incidentId">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="subject">Zona<p-sortIcon field="subject">
                    </p-sortIcon>
                   </th>
                   <th pSortableColumn="subject">Reportado por<p-sortIcon field="subject">
                </p-sortIcon>
               </th>
                    <th pSortableColumn="subject">Asunto<p-sortIcon field="subject">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="body">Detalle<p-sortIcon field="body">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="currDateDtl">Fecha sol<p-sortIcon field="currDateDtl">
                    </p-sortIcon>
                    <th pSortableColumn="comments">Solucion<p-sortIcon field="comments">
                    </p-sortIcon>
                    <th pSortableColumn="spendTime">Hrs<p-sortIcon field="spendTime">
                    </p-sortIcon>         
                </th>     
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-value>
                <tr>
                    <td>{{value.incidentId}}</td>
                    <td>{{value.zonCoord}}</td>
                    <td>{{value.personName}}</td>
                    <td>{{value.subject}}</td>
                    <td>{{value.body}}</td>
                    <td>{{value.currDateDtl}}</td>
                    <td>{{value.comments}}</td>
                    <td>{{value.spendTime}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="p-d-flex p-ai-center p-jc-between">
                    Total {{lstIncidentsAssigned ? lstIncidentsAssigned.length : 0 }} Options.
                </div>
            </ng-template>
        </p-table>

    </div>
    
</div>
   
    
    
    



 
